import { Link } from "react-router-dom";

type SectionTitleProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  moreLabel?: string;
  moreTo?: string;
};

export default function SectionTitle({
  eyebrow,
  title,
  description,
  moreLabel,
  moreTo,
}: SectionTitleProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div className="min-w-0">
        {eyebrow ? (
          <span className="mb-2 flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.28em] text-accent-500">
            <span className="inline-block h-3 w-px bg-accent-500"></span>
            {eyebrow}
          </span>
        ) : null}
        <h2 className="text-xl font-semibold text-foreground-950 md:text-[22px]">{title}</h2>
        {description ? (
          <p className="mt-1.5 text-[13px] leading-relaxed text-foreground-500">{description}</p>
        ) : null}
      </div>
      {moreLabel && moreTo ? (
        <Link
          to={moreTo}
          className="group flex shrink-0 items-center gap-1 text-xs text-foreground-500 transition-colors hover:text-accent-500"
        >
          {moreLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
        </Link>
      ) : null}
    </div>
  );
}